// src/context/BlogContext.tsx
"use client";

import { createContext, useContext, useState, ReactNode } from "react";

export interface BlogData {
  OBJID: number;
  slug: string;
  title: string;
  image: string;
  description: string;
  comment: string;
  pointsTitle: string;
  firstPoints: string;
  pointsTwoTitle: string;
  secondPoints: string;
  conclusion: string;
  conclusionDescription: string;
  MID: number;
  ES_ROW_COLOR: string;
}

interface BlogContextType {
  blogs: BlogData[];
  setBlogs: (blogs: BlogData[]) => void;
}

const BlogContext = createContext<BlogContextType | undefined>(undefined);

export function BlogProvider({ children }: { children: ReactNode }) {
  const [blogs, setBlogs] = useState<BlogData[]>([]);

  return (
    <BlogContext.Provider value={{ blogs, setBlogs }}>
      {children}
    </BlogContext.Provider>
  );
}

export function useBlogContext() {
  const context = useContext(BlogContext);
  if (!context) {
    throw new Error("useBlogContext must be used inside BlogProvider");
  }
  return context;
}
